import dashboardHeaderCss from "../../styles/Dashboard Styles/header.module.scss";
import contactCss from "../../styles/Dashboard Styles/contact.module.scss";
import { useNavigate } from "react-router-dom";

function DashboardHeader({ name, userId }) {
  const navigate = useNavigate();

  function toggleSignOut() {
    let className = `${dashboardHeaderCss.profileOpt}`;
    let profileOpt = document.getElementsByClassName(className)[0];
    profileOpt.classList.toggle(`${dashboardHeaderCss.pBtnActive}`);
  }

  function signOut() {
    localStorage.removeItem("chatappsessiontoken");
    document
      .getElementsByClassName(`${dashboardHeaderCss.navBar}`)[0]
      .removeAttribute("id");
    let contacts = document.getElementsByClassName(`${contactCss.contact}`);
    for (let i = 0; i < contacts.length; i++) {
      contacts[i].removeAttribute("id");
    }
    navigate("/");
  }

  return (
    <>
      <nav className={dashboardHeaderCss.navBar} id={userId}>
        <div className={dashboardHeaderCss.left}>
          <h2>Chatwave</h2>
        </div>
        <div className={dashboardHeaderCss.right}>
          <div className={dashboardHeaderCss.profile} onClick={toggleSignOut}>
            <div className={dashboardHeaderCss.profilePic}>
              <h2>{name.charAt(0)}</h2>
            </div>
            <div className={dashboardHeaderCss.profileOpt} onClick={signOut}>
              <button>Sign Out</button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default DashboardHeader;
